import './index.scss'
import { Controller as BaseController } from 'stimulus'
import { setCookie } from '@app/javascript/classes/cookies'

export class Controller extends BaseController {
  perPageChanged(event) {
    this.rememberSelection(event.target.value)
  }

  rememberSelection(perPage) {
    setCookie('searchPage.perPage', perPage, { longLasting: true, path: '/' })
  }
}
